import { Box, Text } from '@quintoandar-tokko/jopijs';
import RowName from '../../DashboardOverview/RowCards/components/RowName';
import ProgressBar from '../../DashboardOverview/RowCards/components/ProgressBar';
import ItemCount from '../../DashboardOverview/RowCards/components/ItemCount';
import PercentageValue from '../../DashboardOverview/RowCards/components/PercentageValue';
import styles from './concretedOperationsSource.module.scss';
import { CONCRETED_OPERATIONS_INFORMATION } from '../../constants';

export default function ConcretedOperationsSourceRow({
  name,
  percentage,
  count,
  valueInUsd,
  informationMode = CONCRETED_OPERATIONS_INFORMATION.QUANTITY,
  ...rest
}) {
  return (
    <Box className={styles.row} {...rest}>
      <Box className={styles.rowInnerWrapper}>
        <RowName text={name} />
        <ProgressBar percentage={percentage} />

        {informationMode === CONCRETED_OPERATIONS_INFORMATION.QUANTITY && (
          <>
            <ItemCount value={count} />
            <PercentageValue percentage={percentage} />
          </>
        )}

        {informationMode ===
          CONCRETED_OPERATIONS_INFORMATION.TOTAL_VALUE_USD && (
          <Text>{`USD ${valueInUsd}`}</Text>
        )}
      </Box>
    </Box>
  );
}
